import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import { useAppSelector } from './hooks/use-app-selector';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import Home from './pages/HomePage';
import UnidadesMinisteriaisPage from './pages/listagens/UnidadesMinisteriaisPage';
import { AppRoutes } from './shared/routes';
import MembrosPage from './pages/listagens/MembrosPage';
import SincronizacaoPage from './pages/listagens/SincronizacaoPage';
import useAppDispatch from './hooks/use-app-dispatch';
import { useEffect } from 'react';

const App = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return (
    <Layout>
      <Routes>
        {!isAuthenticated && (
          <>
            <Route path={AppRoutes.LOGIN} element={<LoginPage />} />
            <Route path="*" element={<Navigate replace to={AppRoutes.LOGIN} />} />
          </>
        )}
        {isAuthenticated && (
          <>
            <Route path="/" element={<Navigate replace to={AppRoutes.HOME} />} />
            <Route path={AppRoutes.LOGIN} element={<Navigate replace to={AppRoutes.HOME} />} />
            <Route path={AppRoutes.HOME} element={<Home />} />
            <Route path={AppRoutes.UNIDADES_MINISTERIAIS} element={<UnidadesMinisteriaisPage />} />
            <Route path={AppRoutes.MEMBROS} element={<MembrosPage />} />
            <Route
              path={`${AppRoutes.MEMBROS_SINCRONIZAR}/:membroId/:membroNome`}
              element={<SincronizacaoPage />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </>
        )}
      </Routes>
    </Layout>
  );
};

export default App;
